import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './LegalPages.css';

const RefundPolicy = () => {
  return (
    <div className="legal-page">
      <SEO 
        title="Refund & Cancellation Policy | The Prisma Global"
        description="Refund and cancellation policy for The Prisma Global digital products and services."
        canonical="/refund-policy"
      />
      <Navbar />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Refund & Cancellation Policy</h1>
          <p className="last-updated">Last Updated: December 23, 2025</p>
          
          <section>
            <h2>1. Overview</h2>
            <p>At The Prisma Global, we are committed to providing high-quality digital products and services. This policy outlines our refund and cancellation terms.</p>
          </section>

          <section>
            <h2>2. Digital Products (Impact Reports)</h2>
            <h3>No Refund Policy</h3>
            <p><strong>All digital products, including Premium Impact Reports, are non-refundable.</strong></p>
            <p>Because our digital products are delivered instantly and can be accessed immediately upon purchase:</p>
            <ul>
              <li>All sales are final</li>
              <li>No refunds will be issued after successful payment</li>
              <li>No cancellations are accepted once the product is delivered</li>
            </ul>
            
            <h3>Why No Refunds?</h3>
            <p>Digital products cannot be "returned" as they are intangible goods. Once you receive access to the Premium Impact Report, you have full possession of the digital content.</p>
          </section>

          <section>
            <h2>3. Exceptions</h2>
            <p>Refunds may be considered ONLY in the following exceptional circumstances:</p>
            <ul>
              <li><strong>Technical Error:</strong> If you were charged but did not receive the product due to a technical error on our end</li>
              <li><strong>Duplicate Payment:</strong> If you were accidentally charged multiple times for the same product</li>
              <li><strong>Payment Gateway Error:</strong> If payment was deducted but the transaction failed</li>
            </ul>
            <p>To request a refund under these circumstances, contact us within 7 days with proof of the error.</p>
          </section>

          <section>
            <h2>4. Free Products</h2>
            <p>Free Impact Report summaries are provided at no cost. These do not involve any payment and therefore refund policies do not apply.</p>
          </section>

          <section>
            <h2>5. Service-Based Products</h2>
            <h3>Digital Advertising Services</h3>
            <ul>
              <li>Cancellations must be made in writing</li>
              <li>Refunds for ongoing projects are prorated based on work completed</li>
              <li>No refunds for completed campaigns</li>
            </ul>
            
            <h3>Manufacturing Orders (PrismaTex)</h3>
            <ul>
              <li>Custom orders cannot be cancelled once production begins</li>
              <li>Defective products can be replaced within 7 days</li>
              <li>Return shipping costs are borne by the customer</li>
            </ul>
            
            <h3>Real Estate Services (Prisma Terra)</h3>
            <ul>
              <li>Booking amounts are non-refundable</li>
              <li>Cancellation policies are subject to individual agreements</li>
              <li>Refer to your specific property agreement</li>
            </ul>
          </section>

          <section>
            <h2>6. Payment Processing</h2>
            <p>All payments are processed through Cashfree Payment Gateway. Payment disputes should be raised within 7 days of transaction.</p>
            <p><strong>Pricing:</strong> Premium Impact Report - ₹999 (Indian Rupees)</p>
          </section>

          <section>
            <h2>7. Refund Process (If Applicable)</h2>
            <p>In rare cases where a refund is approved:</p>
            <ul>
              <li>Refund will be processed within 7-10 business days</li>
              <li>Amount will be credited to the original payment method</li>
              <li>Bank processing may take an additional 5-7 days</li>
              <li>You will receive email confirmation</li>
            </ul>
          </section>

          <section>
            <h2>8. Contact for Refund Requests</h2>
            <p>For any refund-related queries or exceptional circumstances:</p>
            <p>
              <strong>Email:</strong> info@theprismaglobal.com<br />
              <strong>Phone:</strong> +91-9356-107-460<br />
              <strong>Address:</strong> Next to Markanday Mandir, Kumtha Naka, Solapur 413001, Maharashtra, India
            </p>
            <p>Please include:</p>
            <ul>
              <li>Order/Transaction ID</li>
              <li>Payment proof</li>
              <li>Detailed description of the issue</li>
              <li>Your contact information</li>
            </ul>
          </section>

          <section>
            <h2>9. Chargebacks</h2>
            <p>Initiating a chargeback without contacting us first may result in:</p>
            <ul>
              <li>Suspension of your account</li>
              <li>Legal action for fraudulent claims</li>
              <li>Blacklisting from future purchases</li>
            </ul>
            <p>Please contact us first to resolve any payment disputes.</p>
          </section>

          <section>
            <h2>10. Changes to Policy</h2>
            <p>We reserve the right to modify this Refund & Cancellation Policy at any time. Changes will be posted on this page with an updated revision date.</p>
          </section>

          <section>
            <h2>11. Governing Law</h2>
            <p>This policy is governed by the laws of India. All disputes are subject to the jurisdiction of courts in Solapur, Maharashtra, India.</p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default RefundPolicy;